<template>
  <demo-block v-if="active !== 2">
    <van-swipe
      :autoplay="3000"
      @change="onChange"
      style="height: 200px"
      ref="swipe"
    >
      <van-swipe-item v-for="(image, index) in images" :key="index">
        <van-image :src="image.img" />
        {{ image.title }}
      </van-swipe-item>
    </van-swipe>
  </demo-block>
  <van-notice-bar
    v-if="errorcode === false"
    left-icon="volume-o"
    :text="broadcastmsg"
  />
  <van-notice-bar
    v-if="errorcode"
    left-icon="volume-o"
    :text="errmsg"
  />
  <van-row v-if="errorcode === false" justify="space-between" align="center" :style="this.$store.state.userinfo.status === '挂失'?'background-color:#700000':''">
    <van-col span="5" align="center">
      <van-image
        class="title-img"
        round
        width="5rem"
        height="5rem"
        :src="headpic"
      />
    </van-col>
    <van-col span="6"  offset="0" align="left">
      <van-row style="margin-bottom: 10px">
        <span color="ff0000" style="font-size: 13px;">{{this.$store.state.userinfo.name }}</span>
      </van-row>
      <van-row offset="1">
        <span color="ff0000" style="font-size: 13px;">{{ this.$store.state.userinfo.outid }}</span>
      </van-row>
    </van-col>
    <van-col span="5" offset="0">
      <van-row style="margin-bottom: 10px">
        <span style="color:#000000;font-size:13px">{{this.$store.state.userinfo.dpnames}}</span>
      </van-row>
      <van-row>
        <span v-if="this.$store.state.userinfo.status === '3' || this.$store.state.userinfo.status === '挂失'" color="#ff0000" style="color:#ff0000;font-size:13px">{{this.$store.state.userinfo.status}}</span>
        <span v-else style="color:#74992e;font-size:13px">正常卡</span>
      </van-row>
    </van-col>
    <van-col span="5"  offset="1">
      <van-button style="font-size:30px;margin-right:5px" round :icon="require('/assets/images/qrcode.png')" @click="ShowQrCode"  />
    </van-col>
  </van-row>
  <van-row style="margin-top:5px;margin-bottom:8px;margin-left: 3px;margin-right: 3px;background-color: #fffbe8;border: 2px solid #fffbe8;border-radius: 5px;">
    <van-col span="7"  offset="1">
      <span color="#ff0000" style="font-size:13px">余额{{this.$store.state.userinfo.sumoddfare}}</span>
    </van-col> 
    <van-col span="7"  offset="1">
      <span color="#ff0000" style="font-size:13px">上月消费：{{this.$store.state.userinfo.lastmonthconsume}}</span>
    </van-col> 
    <van-col span="7"  offset="1">
      <span color="#ff0000" style="font-size:13px">本月消费：{{this.$store.state.userinfo.curmonthconsume}}</span>
    </van-col> 
  </van-row>
  <van-grid  clickable column-num="3">
    <van-grid-item  v-for="(item, index) in menulist1"
      :key="index"
      :url="item.link"
      :icon="item.icon" :text="item.functionmemo" :icon-color="item.iconcolor"
      class="menugrid" />
  </van-grid>
  <p align="center" style="margin-bottom:50px;">
    <a href="https://beian.miit.gov.cn" id="beian" target="_blank"> {{this.$store.state.beian}}</a>
  </p>
  <br>
  <van-tabbar v-model="active">
    <van-tabbar-item icon="home-o">主页面</van-tabbar-item>
    <van-tabbar-item to="/useroption" icon="home-o">我的</van-tabbar-item>
  </van-tabbar>
    
  <van-dialog
    v-model:show="dialogInScene"
    :title="dialogTitle"
    show-cancel-button
    @confirm = "InScene"
    :lazy-render="false"
  >
    <img class="imgDialog" :src="require('../../../assets/images/elec.png')" />
  </van-dialog>
  <van-popup v-model:show="showQrCode" :style="{ padding: '50px' }" @close="CloseQRCode()">
    <div ref="qrcode" id="qrcode" @click="ReGetQRCode()" style="margin-bottom: 10px;" />
    <span class="qrcodetext">{{paymessage}}  {{qrcodeoversec}} 秒后刷新   
      <van-icon @click="ReGetQRCode()" name="replay" style="margin-left:20px;color: blue">手动刷新</van-icon>
    </span>
  </van-popup>
  <br>
  
</template>

<script>
  import QRCode from 'qrcodejs2'
  import { requestGetSysInfo, requestGetUserBaseInfo, requestUserQRCode, requestUserQRCodeWSUrl } from '../../api/api'
  import { mapState, mapGetters, mapActions } from 'vuex'
  import { IsBlank, GetBrowserType } from '../../utils/tools/index'
  

import {
  Grid,
  GridItem,
  Image,
  Tabbar,
  TabbarItem,
  Swipe,
  SwipeItem,
  Tag,
  Cell,
  Row,
  Col,
  CouponCell,
  CouponList,
  Popup,
  Icon,
  Dialog,
  Toast,
  NoticeBar,
  ActionBar,
  ActionBarButton,
  ActionBarIcon,
  Button

} from "vant";

export default {
  components: {
    [Grid.name]: Grid,
    [GridItem.name]: GridItem,
    [Image.name]: Image,
    [Tabbar.name]: Tabbar,
    [TabbarItem.name]: TabbarItem,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Cell.name]: Cell,
    [Tag.name]: Tag,
    [Col.name]: Col,
    [Row.name]: Row,
    [CouponCell.name]: CouponCell,
    [CouponList.name]: CouponList,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [NoticeBar.name]: NoticeBar,
    [ActionBar.name]: ActionBar,
    [ActionBarButton.name]: ActionBarButton,
    [ActionBarIcon.name]: ActionBarIcon,
    [Button.name]: Button
  },
  i18n: {
    "zh-CN": {
      text: "文字",
      route: "页面导航",
      gutter: "格子间距",
      square: "正方形格子",
      columnNum: "自定义列数",
      customContent: "自定义内容",
      urlRoute: "URL 跳转",
      vueRoute: "路由跳转",
      showBadge: "徽标提示",
      horizontal: "内容横排",
    },
    "en-US": {
      text: "Text",
      route: "Route",
      gutter: "Gutter",
      square: "Square",
      columnNum: "Column Num",
      customContent: "Custom Content",
      urlRoute: "URL",
      vueRoute: "Vue Router",
      showBadge: "Show Badge",
      horizontal: "Horizontal",
    },
  },
  watch: {
    active(val) {
      if (val === 1) {
        setTimeout(() => {
           // this.$router.push( '/useroption' + '?t111=' + new Date().getTime() );
        }, 500);
      }
    },
  },
  computed: {
    ...mapState({
      token: state => state.token,
      isbind: state => state.isbind,
      userinfo: state => state.userinfo,
      accesstoken: state => state.accesstoken,
      openid: state => state.openid,
      typekey: state => state.typekey
    }),
    ...mapGetters([
      'openidex',
      'hasopenid',
      'isReAuthLogin',
      'isGrid'
    ])
  },
  data() {
    return {
      errorcode: true,
      errmsg: '加载中...',
      headpic: '',
      showQrCode: false,
      loadcontent: '加载中...',
      isLoading: false,
      dialogIcon: '',
      dialogTitle: '进入模式',
      chartindex: 0,
      dialogInScene: false,
      showScene: false,
      active: 0,
      charttitle: "用水信息",
      chosenCoupon: -1,
      exchangedCoupons: [],
      images: [],
      paytype: 0,
      menulist: [
        {menuid: 0, menuname: '拉卡拉充值', icon: 'wechat', link: '#/pay', isshow: false, functionname: 'pay_lakala', iconcolor: '#FF5733' },
        {menuid: 1, menuname: '微信充值', icon: 'wechat', link: '#/pay', isshow: false, functionname: 'wxsave', iconcolor: '#FF5733' },
        {menuid: 2, menuname: '充值订单', icon: 'balance-list', link: '#/pay', isshow: false, functionname: 'wxalipaysavedetail', iconcolor: '#FF5733' },
        {menuid: 3, menuname: '充值订单', icon: 'balance-list', link: '#/payrecent', isshow: false, functionname: 'pay_lakala_recent', iconcolor: '#FF5733' },
        {menuid: 4, menuname: '查询消费', icon: 'after-sale', link: '#/consume', isshow: false, functionname: 'consume', iconcolor: '#FF5733' },
        {menuid: 5, menuname: '查询充值', icon: 'after-sale',link: '#/save', isshow: false, functionname: 'save', iconcolor: '#FF5733' },
        {menuid: 6, menuname: '挂失', icon: 'clear', link: '#/loss' , isshow: false, functionname: 'selfloss', iconcolor: '#FF5733' },
        {menuid: 7, menuname: '门禁功能', icon: 'lock', link: '#/access', isshow: false, functionname: 'wxremotedoor', iconcolor: '#FF5733' },
        {menuid: 8, menuname: '考勤功能', icon: 'location', link: '#/attend', isshow: false, functionname: 'attend', iconcolor: '#FF5733' },
        {menuid: 9, menuname: '照片采集', icon: 'location', link: '#/facepic', isshow: false, functionname: 'face_comset', iconcolor: '#FF5733' },
        {menuid: 10, menuname: '设置', icon: 'setting', link: '#/useroption', isshow: false, functionname: 'option', iconcolor: '#FF5733' },
        {menuid: 11, menuname: '解绑', icon: 'stop-circle-o', isshow: false, functionname: 'unbind', iconcolor: '#FF5733' },
        {menuid: 12, menuname: '绑定', icon: 'stop-circle-o', link: '#/bind', isshow: false, functionname: 'bind', iconcolor: '#FF5733' },
      ],
      qrcode: '',
      qrcodevaliddt: 0,
      qrcodeoversec: 0,
      menulist1: [],
      broadcastmsg: '系统已经开通拉卡拉充值，如果要使用支付宝，请用支付宝扫码进行充值',
      ws: null,
      paymessage: '等待支付中...',
      qrcodeTimer: null,
      wsexit: false,
    };
  },
  
  mounted() {
    var _this = this
    this.paytype = GetBrowserType()
    // 如果有errcode代表是有错误发生了，直接显示错误信息\
    var $errcode = this.$route.query.errcode
    var $errmsg = this.$route.query.errmsg
    console.log('___________________________________________')
      console.log('$errcode', $errcode)
      console.log('$errmsg', $errmsg)
      console.log('___________________________________________')
      console.log(IsBlank($errcode))
    if (IsBlank($errcode) === true) { // 为空
      this.errcode = false
      this.errmsg = '加载完成'
    
      this.errorcode = false
      // 如果accesstoken有信息，那就直接设置进去
      var $accesstoken = this.$route.query.accesstoken
      var $getopenid = this.$route.query.getopenid
      var $token = this.$route.query.localtoken
      console.log('___________________________________________')
      console.log('$token信息', $token)
      console.log('$accesstoken信息', $accesstoken)
      console.log('___________________________________________')
      if (IsBlank($accesstoken) === false) {
        this.$store.commit('UpdateTokenInfo', $accesstoken)
        this.$store.commit('UpdateHasOpenidInfo', $getopenid)
        console.log('开始跳转主页面')
        setTimeout(() => {
          // window.alert('/index' + '?t1=' + new Date().getTime())
          console.log(this.getLocalLoginInfo())
          _this.$router.push( '/index' + '?t111=' + new Date().getTime() );
          console.log(this.getLocalLoginInfo())
          this.GetSysInfo()
          this.GetBaseUserInfo()
          console.log('跳转完毕')
        }, 300);
        // this.getLocalLoginInfo()
      } else {
        console.log(this.getLocalLoginInfo())
        this.GetSysInfo()
        this.GetBaseUserInfo()
      }
    } else {
      console.log('有错误信息出来了，不用跳转了')
      this.errcode = $errcode
      this.errmsg = $errmsg
    }

  },
  methods: {
    CloseQRCode() {
      this.wsexit=true
      if (this.ws) this.ws.close()
      if (this.qrcodeTimer) clearInterval(this.qrcodeTimer)
      this.ws=null
    },
    beforeDestroy() {
      this.CloseQRCode()
    },
    ReGetQRCode() {
      if (this.wsexit) {
        if (this.qrcodeTimer) clearInterval(this.qrcodeTimer)
        return
      }
      if (this.ws!==null && this.ws.readyState === WebSocket.OPEN) {
        this.ws.send(JSON.stringify(this.$store.state.userinfo))
        this.paymessage='二维码.              '
      } else {
        setTimeout(() => {
          console.log('服务器链接失败，重连中...')
          Toast('服务器重连中...' );
          this.ShowQrCode()  
        }, 2000)        
      }
    },
    async ShowQrCode1() {
      const res = await requestUserQRCode(this.$store.state.userinfo)
      if (res.return_code==='0') {
        console.log(res)
        this.qrcode = res.qrcode
      }
      this.showQrCode=true
      // if (this.$refs.qrcode === undefined) return
      if (this.$refs.qrcode !== undefined)
      {
        this.$refs.qrcode.innerHTML = ''
      }
      // 如果有scardsnr，就用他生成二维码 this.$route.query.accesstoken
      console.log('生成的二维码，开始展示1：' + this.qrcode)
      if (this.qrcode === '') this.qrcode = this.$store.state.userinfo.outid
      console.log('生成的二维码，开始展示2：' + this.qrcode)
      setTimeout(() => {
        var qrcode = new QRCode('qrcode', {
          text: this.qrcode, // 表示内容，可以是地址或者是文字'55566'或者参数
          colorDark: '#228b22', // 前景色
          colorLight: '#ffffff', // 背景色
          correctLevel: QRCode.CorrectLevel.H // 容错级别
        })
        qrcode.makeCode(this.qrcode) // 生成另一个新的二维码  
      }, 300);
      
    },
    async ShowQrCode() {
      const _this=this
      this.wsexit=false
      this.paymessage='申请二维码中...'
      const res = await requestUserQRCodeWSUrl({a: 1})
      var url='ws://192.168.0.101:8082/wsqrcode/payment';
      if (res.return_code==='0') url=res.websocketurl
      this.ws = new WebSocket(url)
      var i = 0
      while(this.ws===null && i<3) {
        this.ws = new WebSocket(url)
        i++
      }
      if (this.ws===null) {
        Toast({
          message: '获取支付二维码失败！' ,
          icon: 'fail',
        });
        return
      }
      this.ws.onopen = () => {
        console.log('WebSocket Connected');
        Toast({
          message: '已连接，获取二维码中...' ,
          icon: 'success',
        });
        this.ws.send(JSON.stringify(this.$store.state.userinfo))
      };
      this.ws.onclose = () => {
        console.log('WebSocket Disconnected');
        Toast({
          message: '二维码通道已关闭！' ,
          icon: 'success',
        });
        if (this.wsexit===true) return
        this.CloseQRCode()
        setTimeout(() => {
          console.log('等下自动重新连接...')
          this.ShowQrCode()          
        }, 1200);
      };
      this.ws.onerror = (error) => {
        console.error('WebSocket Error:', error);
        Toast({
          message: '二维码通道发生错误： ' + error ,
          icon: 'fail',
        });
        this.CloseQRCode()
        setTimeout(() => {
          this.ShowQrCode()          
        }, 1200);
      };
      this.ws.onmessage = (event) => {
        console.log(event.data)
        const a=JSON.parse(event.data)
        console.log(a)
        if (a.return_code === '0') {
          console.log(a.status)
          if (a.status===undefined || a.status ===null) {
            _this.qrcode=a.qrcode
            _this.qrcodevaliddt = a.qrcodevaliddt
            this.RefreshQrCode()
            this.paymessage='二维码.              '
            if (this.qrcodeTimer) {
              clearInterval(this.qrcodeTimer);
            }
            _this.qrcodeTimer=setInterval(() => {
              if(this.wsexit) {
                clearInterval(this.qrcodeTimer);
                return;
              }
              console.log('更新一下时间，如果到期，就自动刷新二维码')
              _this.qrcodeoversec = Math.floor(_this.qrcodevaliddt-new Date().getTime()/1000)
              if (_this.qrcodeoversec<=0) {
                _this.qrcodeoversec=0
                this.ReGetQRCode()
              }
            }, 1000);

          } else {
            console.log('得到状态了，开始更新一下'+a.return_message)
            this.paymessage=a.return_message
            if (a.status==='100') { // 说明支付成功了，停止刷新
              if (this.qrcodeTimer) {
                clearInterval(this.qrcodeTimer);
              }
              this.paymessage='支付成功'
              Toast({
                message: _this.paymessage,
                icon: 'success',
              });
            } else if (a.status==='99' || a.status==='41' || a.status==='43') {
              Toast({
                message: a.return_message,
                icon: 'success',
              });
              this.ReGetQRCode()
            }
          }
        }
      }

      this.showQrCode=true
      // if (this.$refs.qrcode === undefined) return
      if (this.$refs.qrcode !== undefined)
      {
        this.$refs.qrcode.innerHTML = ''
      }
      // 如果有scardsnr，就用他生成二维码 this.$route.query.accesstoken
      
      
      
    },
    RefreshQrCode() {
      console.log('生成的二维码，开始展示1：' + this.qrcode)
      if (this.qrcode === '') this.qrcode = this.$store.state.userinfo.outid
      console.log('生成的二维码，开始展示2：' + this.qrcode)
      if (this.$refs.qrcode !== undefined)
      {
       if(this.$refs.qrcode.innerHTML!==null) this.$refs.qrcode.innerHTML = ''
      }
      setTimeout(() => {
        var qrcode = new QRCode('qrcode', {
          text: this.qrcode, // 表示内容，可以是地址或者是文字'55566'或者参数
          colorDark: '#228b22', // 前景色
          colorLight: '#ffffff', // 背景色
          correctLevel: QRCode.CorrectLevel.H // 容错级别
        })
        qrcode.makeCode(this.qrcode) // 生成另一个新的二维码  
      }, 300);
    },
    ...mapActions([
        'getLocalLoginInfo',
        'getIsNeedAuthLogin',
        'clearAccessToken',
        'getBaseUserInfo'
      ]),
    async GetBaseUserInfo(){
      const res = await requestGetUserBaseInfo({accesstoken: this.$store.state.accesstoken})
        if (res.return_code === '0')
        {
          this.$store.commit('updateUserInfo', res.data[0])
          this.menulist1 = []
          res.functionlist.forEach(f => {
            if (f.isshow === '1') {
              if (IsBlank(f.iconcolor)) f.iconcolor = '#FF5733'
              if(f.functionname === 'pay_lakala') {// 拉卡拉充值
                if (this.paytype ===0 || this.paytype === 1) {
                  f.functionmemo = '微信充值'
                  f.icon = 'wechat'
                  f.iconcolor= '#00ac84'
                } else if (this.paytype === 2) {
                  f.functionmemo = '支付宝充值'
                  f.icon = 'alipay'
                  f.iconcolor = '#108ee9'
                } else { 
                  console.log('不支持的充值方式')
                  return
                }
              }
              this.menulist1.push(f)
              return
            }
            });
          this.headpic = res.picserver + res.data[0].outid + '&t1=' + new Date().getTime();
          this.$store.state.userinfo.facepic = res.picserver + res.data[0].outid
        } else {
          Toast({
              message: res.return_message + ',去登录或者重新绑定！' ,
              icon: 'fail',
            });
          this.$router.push( '/bind' + '?t1=' + new Date().getTime());
        }
    },
    async GetSysInfo() {
      const param = {accesstoken: this.accesstoken}
      const res  = await requestGetSysInfo(param)
       if (res.return_code === '0') {
        console.log(res)
        this.images = res.bannerinfo
        this.$store.state.beian = res.beian
        this.$store.state.isenablewxpay = res.isenablewxpay
        this.$store.state.isenablealipay = res.isenablealipay
        document.title = res.systemname[0].dpname + ' 服务平台' 
        if (res.broadcastmsg.length>0) this.broadcastmsg = res.broadcastmsg[0].broadcastmsg
        // console.log(res)
      } else {
        Toast({
          message: res.return_message ,
          icon: 'fail',
        });
      }
    },
    async CheckBind() {
      // 先检查当前localtoken和accesstoken有没有绑定信息

    },
    ClickMenu (param) {
      console.log(param);
      // Toast(param)
      setTimeout(() => {
        this.$router.push( param +  '?t1=' + new Date().getTime());        
      }, 300);
    },
    beforeClose(action, done) {
      if (action === 'confirm') {
        setTimeout(done, 1000);
      } else {
        done();
      }
    },
    InScene() {
      console.log('ok')
      Toast({
        message: this.dialogTitle + '成功',
        icon: this.dialogIcon,
      });
    },
    onChangeScene(index) {
      this.showScene = false;
      this.chosenCoupon = index;
    },
    randomId(max = 999999) {
      return Math.floor(Math.random() * max) + 1;
    },
    onChange(index) {
      this.current = index;
    }
  },
};
</script>

<style lang="less">
.van-grid {
  display: flex;
  flex-wrap: wrap;
}
.menugrid {
  // display: flex;
  flex-wrap: wrap;
  background-color: transparent;
  margin-bottom: 5px;
  // margin-left: 3px;
}
.van-grid-item__content {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    height: 100%;
    padding: var(--van-grid-item-content-padding);
    background: transparent;
}
.qrcodetext {
  margin-left: 5px;
  margin-top: 35px;
  color: #3c3c3f;
  font-size: 15px;
  font-family:"微软雅黑",Georgia,Serif;
}
.img1 {
  height: 60px;
}
.imgDialog {
  box-sizing: border-box;
  width: 100%;
  padding: 25px 20px 0;
}
</style>
